module.exports = __webpack_public_path__ + "./timer-worker.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=./timer-worker.js!./src/core/timer-worker.js
// module id = 2510
// module chunks = 0